import Components from "slotworks/components/components";
import GameState from "slotworks/model/game-state";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import settingsModel from "slotworks/model/settings/settings-model";
import { Services } from "slotworks/services/services";
import { SoundEvent } from "slotworks/services/sound/sound-events";
import Contract from "slotworks/utils/contracts/contract";

export function StartSpinCommand(): Contract<void> {
    const gameplay = GameState.getCurrentGame();

    Services.transaction.setBalance(gameplay.startBalance);

    const record = gameplay.getCurrentRecord();
    if (record && (record instanceof FreespinRecord || record.getFreespinsWon() > 0)) {
        Services.sound.event(SoundEvent.start_freespin);
    } else {
        Services.sound.event(SoundEvent.start_spin);
    }

    return Components.matrix.startTransition(false, settingsModel.getQuickSpin());
}
